export const stripeKey = process.env.STRIPE_PUBLISHABLE_KEY;
export const stripeClientId = process.env.STRIPE_CLIENT_ID;
export const googleMapsKey = process.env.GOOGLE_MAPS_API_KEY;
